const onlyUnique = (value, index, self) => {
  return self.indexOf(value) === index;
}

const parameterize = (char) => {
  return char.toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/(^-|-$)/g,'');
}

export { onlyUnique, parameterize }
